import { isValidPhoneNumber } from 'libphonenumber-js'

export const isValidName = (value: string): boolean => {
  return /^[A-Za-zÀ-ÿ]+(?:[ '-][A-Za-zÀ-ÿ]+)*$/.test(value)
}

export const isValidPhone = (value: string): boolean => {
  if (!value) return true // même logique qu’avant
  return isValidPhoneNumber(value, 'CA')
}
